import { useRef } from "react";
import isEqual from "lodash/isEqual";

/** Keeps the previous reference while the next value is deep-equal, so a
 *  rebuilt value with the same contents does not rerun memos and effects. */
export function useStableWhileEqual<T>(next: T): T {
  const kept = useRef(next);
  if (!isEqual(kept.current, next)) kept.current = next;
  return kept.current;
}
